import 'slick-carousel';
import 'magnific-popup';

export default ($container) => {
    $('.js-carousel', $container).slick({
        rows:     0,
        fade:     true,
        asNavFor: '.js-carousel-thumb',
        infinite: false,
    });

    $('.js-carousel-thumb', $container).slick({
        rows:            0,
        verticalSwiping: true,
        vertical:        true,
        infinite:        false,
        arrows:          false,
        focusOnSelect:   true,
        slidesToShow:    6,
        asNavFor:        '.js-carousel',
        responsive:      [
            {
                breakpoint: 768,
                settings:   {
                    verticalSwiping: false,
                    vertical:        false,
                },
            }
        ],
    });

    $('.js-photo-popup', $container).magnificPopup({
        type:                'image',
        closeOnContentClick: true,
        mainClass:           'mfp-img-mobile',
        image:               {
            verticalFit: true,
        },
    });

    $('.js-product-slider', $container).each(function() {
        const cardCount = $('.card-product', this).length;
        $(this).slick({
            rows:         0,
            infinite:     false,
            arrows:       false,
            slidesToShow: Math.min(3, cardCount),
            responsive:   [
                {
                    breakpoint: 992,
                    settings:   {
                        slidesToShow: Math.min(2, cardCount),
                    },
                },
                {
                    breakpoint: 768,
                    settings:   {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });

    $('.js-popular-choices', $container).each(function() {
        const cardCount = $('.card-popular', this).length;
        $(this).slick({
            rows:         0,
            slidesToShow: Math.min(4, cardCount),
            responsive:   [
                {
                    breakpoint: 1200,
                    settings:   {
                        slidesToShow: Math.min(3, cardCount),
                    },
                },
                {
                    breakpoint: 992,
                    settings:   {
                        slidesToShow: Math.min(2, cardCount),
                    },
                },
                {
                    breakpoint: 768,
                    settings:   {
                        arrows:       false,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });
};
